import { useRef, useState } from 'react';
import { TextInput } from '@ardoq/forms';
import { useMetamodelEditorContext } from '../state';

type AddLeafButtonProps = {
  parentMetamodelTypeId?: string;
  onEditEnd?: () => void;
};

export const CreateNodeInput = ({
  parentMetamodelTypeId,
  onEditEnd,
}: AddLeafButtonProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [name, setName] = useState<string>('');
  const { addMetamodelType, validateName, labels } =
    useMetamodelEditorContext();
  const onCancelEdit = () => {
    setErrorMessage('');
    setName('');
    onEditEnd?.();
  };
  return (
    <TextInput
      ref={ref}
      placeholder={labels.createNodePlaceholder}
      autoFocus
      errorMessage={errorMessage}
      value={name}
      onValueChange={setName}
      onBlur={onCancelEdit}
      onKeyDown={async ({ key }) => {
        try {
          setErrorMessage('');
          if (key === 'Enter') {
            validateName({ name });
            addMetamodelType({
              name,
              parent: parentMetamodelTypeId,
            });
          }
          if (key === 'Escape' || key === 'Enter') {
            onCancelEdit();
          }
        } catch (error) {
          ref.current?.focus();
          let message = labels.createNodeUnknownError;
          if (error instanceof Error) message = error.message;
          setErrorMessage(message);
        }
      }}
    />
  );
};
